import LessonProgressListSkeleton from '@/components/lesson-progress/LessonProgressListSkeleton';
import { Divider, Skeleton } from '@/components/ui/daisy';

const COLLAPSED_UNIT_COUNT = 4;
const SHORTCUT_COUNT = 3;

export default function UnitListSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      <OpenUnitSkeleton />
      {Array.from({ length: COLLAPSED_UNIT_COUNT }, (_, index) => (
        <Skeleton key={index} className="h-19 w-full rounded-2xl" />
      ))}
    </div>
  );
}

function OpenUnitSkeleton() {
  return (
    <div className="flex flex-col rounded-2xl bg-base-200">
      <div className="flex min-h-19 items-center gap-3 p-4 pe-12">
        <Skeleton className="h-5 w-40 rounded-lg md:w-64" />
      </div>
      <div className="flex flex-col gap-4 px-3 pb-4 md:px-4">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between md:gap-2">
          <Skeleton className="h-30 w-full shrink-0 rounded-2xl md:w-64" />
          <ul className="flex gap-2 md:ml-auto md:shrink-0">
            {Array.from({ length: SHORTCUT_COUNT }, (_, index) => (
              <li key={index} className="min-w-0 flex-1 md:flex-none">
                <Skeleton className="h-18.5 w-full rounded-2xl md:w-24" />
              </li>
            ))}
          </ul>
        </div>
        <div className="flex items-center gap-4 py-4">
          <Skeleton className="h-4 w-14 rounded-md" />
          <Divider className="m-0 mt-0.5 flex-1" />
          <Skeleton className="h-5 w-16 rounded-full" />
        </div>
        <LessonProgressListSkeleton />
      </div>
    </div>
  );
}
